export default __webpack_public_path__ + "static/media/central_andes_1_9.ae05e34d.JPG";